import React from "react";
import { formatTxnAmount } from "../utils/currency";
import { t } from "../i18n";

// "Accept Setlist Purchase?" confirm on the Requests page — accept only
// moves the card; the fan is charged at delivery. Split out of
// pages/RequestsPage.tsx; the page owns which sale is waiting.

type Props = {
  sale: { amount: number; currency?: string };
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function PlaylistAcceptModal({ sale, busy, onCancel, onConfirm }: Props) {
  return (
    <div
      className="soon-modal-overlay"
      onClick={(e) => {
        if (e.target !== e.currentTarget) return;
        if (!busy) onCancel();
      }}
    >
      <div className="soon-modal playlist-accept-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="playlist-accept-title">{t("playlistAcceptModal.acceptSetlistPurchase")}</h3>
        <div className="playlist-accept-amount">
          {formatTxnAmount(sale.amount, sale.currency)}
        </div>
        <p className="playlist-accept-body">
          {t("playlistAcceptModal.youMustUploadYour")}
        </p>
        <div className="playlist-accept-actions">
          <button
            type="button"
            className="playlist-accept-go"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? t("playlistAcceptModal.accepting") : t("playlistAcceptModal.accept")}
          </button>
          <button
            type="button"
            className="playlist-accept-later"
            onClick={onCancel}
            disabled={busy}
          >
            {t("playlistAcceptModal.notNow")}
          </button>
        </div>
      </div>
    </div>
  );
}
